import {CategoryContext, CategoryContextProps} from "../components/CategoryContext";
import {useContext} from "react";

export const encodedOrDefault = (val: string | undefined | number | null, defaultValue = ' ') => {
    const value = val ? val : defaultValue;
    const encoded = encodeURIComponent(value);
    return encoded ? encoded : defaultValue;
};

export const retrieveErrorMessage = (e: unknown): string => {
    if (e instanceof Error) {
        return e.message;
    }
    if (typeof e === 'string') {
        return e;
    }
    const b = e as object;
    if (b && 'message' in b && typeof b.message === 'string') {
        return b.message;
    }
    return 'Unknown error occured';
}

export type getDeepLink = (context: Partial<CategoryContextProps>) => string;
export type getContext = (argument?: string) => CategoryContextProps;
export type meaningFullName = keyof CategoryContextProps;

export const useDeepLink = (): [getDeepLink, getContext] => {
    const currentContext = useContext(CategoryContext);
    const meaningfullProps: meaningFullName[] = ['currentCategory', 'currentPage', 'pageSize', 'query', 'article'];

    const mapMeaningFullName = (name: meaningFullName, value: string): number | string | null => {
        switch (name) {
            case "currentCategory":
                return Number(value);
            case "currentPage":
                return Number(value);
            case "pageSize":
                return Number(value);
            case "query":
                return decodeURIComponent( value );
            case "article":
                return Number(value);
            default:
                return null;
        }
    }

    return [
        (context: Partial<CategoryContextProps>): string => {
            const merged = { ...currentContext, ...context };
            return btoa( meaningfullProps.map( n => merged[n] ? merged[n] : '' ).join(':|:') );
        },
        (argument?: string): CategoryContextProps => {
            if (!argument) {
                return currentContext;
            }
            const decoded = atob(argument);
            const parts = decoded.split(':|:');
            const output = meaningfullProps.map( (name, idx) => ({[name]: mapMeaningFullName(name, parts[idx] ) })).reduce((acc, cur) => ({...acc, ...cur}), {...currentContext});

            console.info(output);

            return output;
        }
    ];
}